/**
 * Registers a directive for changing the language in an AngularJS module.
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerChangeLanguageDirective(module) {
    /**
     * Defines the 'changeLanguage' directive.
     * @param {function} $compile - The AngularJS $compile service.
     * @returns {object} - The directive definition object.
     */
    module.directive('changeLanguage', ['$compile', function($compile) {
        return {
            /**
             * Restricts the directive to be used as an element or attribute.
             */
            restrict: 'EA',
            /**
             * Determines whether the directive replaces the element it's attached to.
             * Set to false to preserve the original element.
             */
            replace: false,
            /**
             * Specifies the URL of the template to be used by the directive.
             */
            templateUrl: '/views/ib/components/changeLanguage/changeLanguage.html',
            /**
             * Specifies the controller for the directive.
             */
            controller: 'ChangeLanguageDirectiveController',
            /**
             * Creates an alias for the controller instance in the scope.
             */
            controllerAs: 'ctrl'
        };
    }]);
}